export default __webpack_public_path__ + "1a1c41c28198a4e717c4af39a7bae41e.png";